<template>
<div class="container-fluid" >

 <div class="card border-primary">

  <div class="card-header text-white bg-primary">
    <h4><i style="color:yellow" class="fas fa-project-diagram mr-2" aria-hidden="true"></i>RESTOCKING SEDE</h4>
  </div> 

 <div v-if="type=='A'" style="color:black" class="card-body"> 
 

 <div class="row">


  <div v-if="params"> 
  

  <div class="" >
  <div class="">
    <i style="color:blue" class="fas fa-stream mr-2" aria-hidden="true"></i>  
  <strong>PARAMETRI DI RICERCA</strong>
    <hr>
  </div>
  <div class="card-body text-black">

  <form name="filter" v-on:submit.prevent="submit()">
    <div class="form-row">
    <div class="col">
        <store-select v-bind:props="store"  @update="setStoreId"></store-select>
        <storeSelectTo v-bind:props="stockStore"  @update="setStockStoreId"></storeSelectTo>
    </div>
      <div class="col">    

        <label for="date_doc"><strong>da Data vendita</strong></label>
        <input :disabled="rows.length>0" required v-model="data1" type="date" class="form-control" placeholder="" >        
    </div>
    <div class="col">
        <label for="date_doc"><strong>a Data vendita</strong></label>
        <input :disabled="rows.length>0" required v-model="data2" type="date" class="form-control mb-3" placeholder="" >        
      </div>
     </div>   

        <category-grouping v-bind:props="catGrouping" @update="setGroupCategoryId"></category-grouping>  
        <category-select v-bind:props="category"  @update="setCategoryId"></category-select>        
        <department-select v-bind:props="department"  @update="setDepartmentId"></department-select>
        <season-select v-bind:props="season" @update="setSeasonId"></season-select>
        <yearVueSelect @update="setYear" v-bind:props="season_year"></yearVueSelect>
      
    <div class=""> 
      <button type="submit"  class="btn btn-primary float-right">
        <i class="far fa-play-circle mr-2"></i>
        ESEGUI RICERCA
        <span v-if="spinner" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
      </button>           

   


      <alert-box style="margin-top:10px" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>    
    </div>

  </form>
  </div>
  </div>
  </div>

  <div v-else class="col_">
    <h5 style="color:blue" class="card-title ml-3">SEDE IN RESTOCKING <strong>{{title.store}}</strong></h5>
    <button  v-if="rows.length>0"  @click="rows=[],params=true" type="button"  class="btn btn-secondary mb-1 ml-2">
   <i style="color:yellow" class="fas fa-reply mr-2"></i>
  ANNULLA
  </button>  

<button v-if="rows.length>0" :disabled="rows.length==0 || spinner_pdf == true" @click="pdf()" type="button"   class="btn btn-primary  ml-3 mb-1">


<i class="fas fa-file-export mr-2"></i>
      ESPORTA PDF
      <span v-if="spinner_pdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>  


  
  <product-img v-if="img" @close="img=''" v-bind:img='img'></product-img>    
   
  <div class="table-responsive">              
  
  <div class="table-wrapper-scroll-y my-custom-scrollbar">
  <table class="table table-bordered table-sm table-hover pointer" id="my-table">
    <thead class="thead-light">
      <tr>
        <th  :style="styleObject(index)" v-for="(col,index) in cols" :key="index">
          
       
           <span class="ml-1">{{col}}</span> 
        </th>
      </tr>
    </thead>
    <tbody>
      <tr data-toggle="tooltip" title="doppio click visualizza STOCK" @dblclick="getProductStock(item.productId)"  v-for="(item, index) in rows" :key="index">
   
   
        <td v-for="(col,index1) in cols" :key="index1">

          <button v-if="index1==1" class="btn btn-default"  @click="getProductImg(item)">
            <i style='color:black;' data-toggle="tooltip" title="Image"  class="fas fa-camera" aria-hidden="true">
               
            </i>
          </button>
          <label  v-else-if="index1==0"   class="text-center">{{index+1}}</label>
          <label  v-else class="text-center">{{item[col]}}</label>
          
              
        </td>
      </tr>
    </tbody>
  </table>



<!-- Table -->
 </div>
</div>
 



  </div>  

  </div>


 
  

 </div>

<div v-else>
     <stock @close="type = 'A'" v-bind:item="item" />
</div>    


 </div>

  

</div>


</template>
<script>



import api               from '@/api'
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import categoryGrouping  from '@/components/common/CategoryGroupingSelect_1.vue';



import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import categorySelect    from '@/components/common/CategorySelect_1.vue'



import yearVueSelect     from '@/components/common/YearVueSelect.vue'
import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'
import storeSelect       from '@/components/common/StoreSelect_1.vue'
import storeSelectTo     from '@/components/common/StoreSelect_1.vue'
import productImg        from '@/components/common/ProductImg.vue'
import stock             from '@/components/product/productStock.vue'
import jsPDF             from 'jspdf';
//import 'jspdf-autotable'
import autoTable from 'jspdf-autotable'


export default {
  components: {alertBox,departmentSelect,storeSelect,productImg,stock,seasonSelect,categorySelect,categoryGrouping,storeSelectTo,yearVueSelect},
  data() {
    return {
      params          : true,
      rows            : [],
      
      store          : {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        label         : 'SEDE IN RESTOCKING'
      },

      stockStore      : {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : true,
        label         : 'SEDE STOCK'
      },
      season          : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },

      department      : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },
      category        : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
        groupId       : 0
      },
      catGrouping     : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : true,
        Ids           : '',
        selection     : []

      },

      type            : 'A', 
      //supplierId      : null,
      
      
      
      data1           : new Date().toISOString().slice(0,10),
      data2           : new Date().toISOString().slice(0,10),
      
      //year            : 0,
      
      
      spinner         : false,
      spinner_pdf     : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      

      cols            : [],
      
      img             : '',
      item            : {},
      title           : {store:'',categoryGrouping:'',category:'',department:'',season:''}
     
      
    };
  },
  computed:
  {

    
  },
 
  
  computed :{
    ...mapGetters(['company']),

    
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    //this.getGrouping()
  },
  methods: {

    setYear(Ids,text)
    {
      
      let season_yearIds         = ''      
      //this.pdf_title.year        = text
      this.season_year.selection = Ids
     
      if (Ids.length > 0)
      {
        season_yearIds = Ids.join() 
      }
      this.season_year.Ids = season_yearIds
      console.log('setYear',Ids)
    },
    styleObject :function (index)
     {

      let obj = {}
      if(index > 11 )
      {

        obj =  {color:'white','backgroundColor':'green'}
      }
      return obj
     }, 
   header_pdf()
   {
      
      
      let title = ''
      title =

      this.title.store  + ' ' + 
      
      this.title.categoryGrouping + ' ' + this.title.category + ' ' + this.title.department + ' '  + this.title.season
      
      return title
    


   }, 
   getProductImg(item)
   {
       this.img = item.img
   }, 
   async  pdf()
    {
      function wait(ms) 
      {
          return new Promise(resolve => {
          setTimeout(() => { resolve('') },ms);
          })
      }
      

      this.spinner_pdf = true
      await wait(0)
      const addFooters = doc => {
      const pageCount = doc.internal.getNumberOfPages()
      doc.setFont('helvetica', 'italic')
      doc.setFontSize(8)
      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)

        doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 50,200, {
        align: 'center'})
      }
      }
       
      


       const doc = new jsPDF(
         
         {
         
       orientation: "landscape",

        
      })
      doc.setFontSize(8)
      var d = new Date();
      var n = d.toLocaleDateString();
      var t = d.toLocaleTimeString();
      doc.text("RESTOCKING LIST   " + n + ' ' + t , 15, 10);
      doc.setFontSize(10)
      doc.text( this.header_pdf()  , 15, 15);
     
      doc.autoTable(
      
    
       { html: '#my-table',
       margin       : {top:20},
       showFoot: 'lastPage',
       footStyles:{fontStyle:'bold',fillColor:'white',textColor:'black',fontSize:7,cellWidth: 'wrap',},

          didParseCell: function(data) {
            if (data.row.cells[0].text == 'Tot. Raggruppamento') {
              
              
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fontSize = 6
              //console.log(data.row.cells[0].text)

            }
          


          
          }, 



       styles : {
          font       : 'helvetica',
          //rowHeight  : 5,  
          fontSize   : 6,
          }
        })
      
     
     addFooters(doc) 
    //var string = doc.output('datauristring');
    //doc.output('dataurlnewwindow');
    
    
    this.spinner_pdf = false
    
    var fileName = 'Report'
    window.open(doc.output('bloburl', { filename: fileName }), '_blank');
    //console.log(string)
    
    //doc.save('sellOut_' + Date.now()  + '.pdf', {returnPromise:true}).then(this.spinner_pdf=false);
      
     
    },
    setGroupCategoryId(Id,e)
    {
      this.catGrouping.Id = Id
      //this.category.groupId = Id
      this.title.categoryGrouping = e.target.options[e.target.options.selectedIndex].text
      

    },
    setCategoryId(categoryId,e)
    {
      this.category.Id = categoryId
      this.title.category = e.target.options[e.target.options.selectedIndex].text

    },

    setDepartmentId(departmentId,e)
    {
      this.department.Id = departmentId
      this.title.department = e.target.options[e.target.options.selectedIndex].text
      //this.department.Id = departmentId
    },
    setSeasonId(seasonId,e)
    {   
        this.season.Id = seasonId
        this.title.season = e.target.options[e.target.options.selectedIndex].text
        
        //this.season.Id = seasonId
    },  

    
    setStoreId(storeId,e)
    {
      this.store.Id = storeId
      this.title.store = e.target.options[e.target.options.selectedIndex].text
      
    },
    setStockStoreId(storeId,e)
    {

      this.stockStore.Id = storeId
      //this.title.store = e.target.options[e.target.options.selectedIndex].text
      
    },
    submit() 
    {
      this.getData()
    },  
    
    
       
    getProductStock(productId)
    {   
        let item = {}
        item.productId = productId
        item.storeId = this.store.Id
        this.item = item
        this.type = 'B'
        
    },
    async getData() {
      
      
      this.rows = []
      
      this.msg.title = ''
            
      const sp = {'sp' : 'spProductStoreRestocking'}           
      const data  = {
        'companyId':this.company.Id,'data1':this.data1,'data2':this.data2,'departmentId':this.department.Id,'storeId':this.store.Id,'seasonId':this.season.Id,
        'categoryId' : this.category.Id,'cat_groupId' : this.catGrouping.Id,'toStoreId' : this.stockStore.Id,
        'season_year' : this.season_year.Ids

      }
      
      
     console.log('Restocking',data)

      const json  = Object.assign(data, sp)

      this.spinner = true
      
      await api.post(json).then(res => {
         
          if(res.status==200)
            {
              

              if(res.data.recordsets[0].length == 0)
              {
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'DATI INESISTENTI.'
                this.msg.type  = 1
                return

              }

                

                let items = res.data.recordsets
                let tmp = [];
                tmp.push('#')
                let cols = items[1][0].cols.split('|')
           
                cols.forEach(e => {
                    tmp.push(e)  
                });          
                this.cols = tmp
                
                this.rows = items[0]
                this.params = false
            }
            else if (res.status==500)
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type  = 1
              
            }
          
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type  = 1
                
                        

          }
      }).catch(err=>{
        
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type  = 1
              

      }).finally(() => {
          this.spinner = false
        });
      
 

    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 600px;
overflow   : auto;
}
.pointer:hover
{
   /* 
  background-color : blue;
  color      : white;
  */
  cursor     : pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;

    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;
    
    
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : whitesmoke;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }


.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
 
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
</style>